import React from "react";
import PropTypes from "prop-types";

const CheckFileIcon = ({
  width,
  height,
  className,
  color,
  stroke,
  strokeWidth,
  selected,
  ...props
}) => {
  const strokeColor =
    stroke && stroke !== "currentColor" ? stroke : color || "#31237D";

  return (
    <svg
      width={width || 20}
      height={height || 20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      opacity={selected ? 1 : undefined}
      className={className}
      {...props}
    >
      <path
        d="M7.49984 1.66663H12.4998C12.9601 1.66663 13.3332 2.03972 13.3332 2.49996V4.16663C13.3332 4.62686 12.9601 4.99996 12.4998 4.99996H7.49984C7.0396 4.99996 6.6665 4.62686 6.6665 4.16663V2.49996C6.6665 2.03972 7.0396 1.66663 7.49984 1.66663Z"
        stroke={strokeColor}
        strokeWidth={strokeWidth || "1.66667"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3335 3.33337H15.0002C15.9206 3.33337 16.6668 4.07957 16.6668 5.00004V16.6667C16.6668 17.5872 15.9206 18.3334 15.0002 18.3334H5.00016C4.07969 18.3334 3.3335 17.5872 3.3335 16.6667V5.00004C3.3335 4.07957 4.07969 3.33337 5.00016 3.33337H6.66683"
        stroke={strokeColor}
        strokeWidth={strokeWidth || "1.66667"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 11.6667L9.16667 13.3333L12.5 10"
        stroke={strokeColor}
        strokeWidth={strokeWidth || "1.66667"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

CheckFileIcon.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  color: PropTypes.string,
  stroke: PropTypes.string,
  strokeWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  selected: PropTypes.bool,
};

CheckFileIcon.defaultProps = {
  width: undefined,
  height: undefined,
  className: "",
  color: undefined,
  stroke: undefined,
  strokeWidth: undefined,
  selected: false,
};

export default CheckFileIcon;
